module.exports = __webpack_public_path__ + "img/paypalPAY.c0a67781.svg";